(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('ActionConfirmationModalController', ActionConfirmationModalController);

    /** @ngInject */
    function ActionConfirmationModalController($uibModalInstance, modalImage, modalTitle, modalDescription, buttonStyle) {
        var vm = this;

        vm.modalImage = modalImage;
        vm.modalTitle = modalTitle;
        vm.modalDescription = modalDescription;

        vm.getButtonClass = function () {
            return buttonStyle === 'ERROR' ? 'error-button' : '';
        };

        vm.close = function (confirm) {
            $uibModalInstance.close(confirm);
        };
    }
})();
